var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"Rectangle","fill":"#ffb443","points":"0 0 214 0 0 793"}));
}

Triangle.defaultProps = {"width":"214px","viewBox":"0 0 214 793","version":"1.1"};

module.exports = Triangle;

Triangle.default = Triangle;
